package com.veldekar.components.logs

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*
import com.veldekar.components.widgets.LocalizedSessionDate
import com.veldekar.components.widgets.InvertibleImage

@Composable
fun Log_2024_09_27_Day_1() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("We return to our heroes who are eagerly anticipating dinner with Lady Aventary on Newgrowth 55. Our heroes do not see Ludwig Voss in the city.")
    }
}
